<template src="./ViewGenCertificado.html"></template>

<script>
import {Breadcrumb, BreadcrumbItem} from "element-ui";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import moment from "moment";
import {NotifyMixin} from "@/mixins/NotifyMixin";
import {requesCertificadosMixin} from "@/api/certificadosApi";
import GenCertificadoDetail from "@/components/Shared/GenCertificadoDetail/GenCertificadoDetail";

export default {
  name: "ViewGenCertificado",
  components: {
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    GenCertificadoDetail
  },
  mixins: [
    ScreenSizeMixin,
    requesCertificadosMixin,
    NotifyMixin
  ],
  data: () => ({
    loading: true,
    errored: false,
    inRoute: false,
    model: {
      id: "",
      rut: "",
      nombreCompleto: "",
      estado: "",
      estadoCodigo: 0,
      fecha: '',
      hora: '',
      document: null
    },
  }),
  props: {
    id: {
      type: String,
      required: false
    }
  },
  beforeMount() {
    this.getId()
    this.genCertificadoView()
  },
  computed: {
    getShadow: function() {
      if (this.$route.params.hasOwnProperty('id')) {
        return 'always'
      }
      return 'never'
    }
  },
  methods: {
    getId() {
      if (this.$route.params.hasOwnProperty('id')) {
        this.model.id = this.$route.params.id
        this.inRoute = true
      } else {
        this.model.id = this.id
      }
    },
    genCertificadoView() {
      this.getCertificadoAfiliacionView(this.model.id)
        .then(response => {
          this.$log.debug('getCertificadoAfiliacionView', this.model.id, response.data.statusCode)
          if (response.data.statusCode === 200) {
            const data = JSON.parse(response.data.datos);
            this.$log.debug(data)

            this.convertDataToModel(data)

            this.errored = false
          } else {
            this.messageError(response.data.statusCode)
          }
        })
        .catch(err => {
          this.$log.fatal('getCertificadoAfiliacionView', err, this.model.id)
          this.messageError(err.request.status)
        })
        .finally(() => {
          this.loading = false
        })
    },
    convertDataToModel(data = {}) {
      this.model.rut = data.cedula
      this.model.nombreCompleto = data.nombrecompleto

      this.model.estado = data.estado
      this.model.estadoCodigo = data.estadocodigo

      const mfecha = moment.utc(data.fecha).local()
      this.model.fecha = mfecha.format('DD-MM-YYYY')
      this.model.hora = mfecha.format('h:mm a')

      this.model.document = data.documento
    },
    messageError(statusCode) {
      this.errored = true
      let message = 'Ocurrió un error inesperado al cargar el certificado de afiliación'
      if (statusCode === 404) {
        message = 'El certificado de afiliación'
      }
      this.showError(message)
      this.$emit('on-error-close', true)
    },
  }
}
</script>
